// TOP お役立ちコラムの SP スライダー（Swiper）。
// PC では init せず、md（max-width:768px）境界で init / destroy する。
// Swiper は CDN（window.Swiper）前提。未読み込みなら何もしない。

const SP_QUERY = '(max-width: 768px)'; // DaiCSS の md（767）に一致

const topColumnSlider = () => {
  const SwiperLib = window.Swiper;
  if (!SwiperLib) return;

  const container = document.querySelector('.js-top-column-slider');
  if (!container) return;

  const pagination = document.querySelector('.js-top-column-pagination');
  let swiper = null;

  const init = () => {
    if (swiper) return;
    // 1件以下はスライダー化しない。2件は loop なし。3件以上で従来通り loop + 中央寄せ
    const slideCount = container.querySelectorAll('.swiper-slide').length;
    if (slideCount <= 1) {
      pagination?.setAttribute('hidden', '');
      return;
    }
    pagination?.removeAttribute('hidden');

    swiper = new SwiperLib(container, {
      loop: slideCount >= 3,
      centeredSlides: slideCount >= 3,
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 400,
      pagination: { el: pagination, clickable: true },
    });
  };

  const destroy = () => {
    if (!swiper) return;
    swiper.destroy(true, true);
    swiper = null;
  };

  const mq = window.matchMedia(SP_QUERY);
  const handleChange = () => (mq.matches ? init() : destroy());
  mq.addEventListener('change', handleChange);
  handleChange();
};

export { topColumnSlider };
